import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ToggleSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgb(247, 248, 248);
  border-radius: ${pxToRem(15)};
  padding: ${pxToRem(4)};
  width: 100%;
  margin-bottom: ${pxToRem(24)};
`;

export const ToggleButton = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: ${pxToRem(8)} ${pxToRem(16)};
  border: none;
  border-radius: ${pxToRem(13)};
  font-size: ${pxToRem(14)};
  font-weight: 500;
  cursor: pointer;
  
  background: ${({ isActive }) =>
    isActive ? "rgb(114, 82, 220)" : "transparent"};
  color: ${({ isActive }) => (isActive ? "white" : "rgb(163, 167, 174);")};
  transition:
    background-color 0.2s,
    color 0.2s;

  &:hover {
    color: ${({ isActive }) =>
      isActive ? "white" : "rgb(114, 82, 220);"};
  }
`;
